import {
  Frame,
  TopBar,
  Navigation,
  Box,
} from '@shopify/polaris';
import {
  CashDollarIcon,
  PersonIcon,
  SearchIcon,
  SettingsIcon,
} from '@shopify/polaris-icons';
import { useEffect, useState } from 'react';
import { usePartnerUp } from '../providers/PartnerUpStoreProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import CreditsPopup from './CreditsPopup';
import { doc, setDoc } from 'firebase/firestore';

export default function AppLayout({ children, menuDisabled = false }) {
  const { auth, db, user, refetchUser, noUser, inviteModalState, leads } = usePartnerUp();
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);

  const [popup, setPopup] = useState(null)

  const unseenCount = leads?.filter(lead => !lead.seen).length

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // listen for auth state changes
    const unsub = auth.onAuthStateChanged((user) => {
      if (auth._isInitialized && !user) {
        navigate('/login')
      }
    });
    return unsub;
  }, []);

  if (noUser) {
    if (location.pathname !== '/onboarding') {
      navigate('/onboarding')
    }
  }

  console.log('user', user)

  /*
  if (!auth._isInitialized) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>
        <Spinner size="large" color="teal" />
      </div>
    )
  }
  */

  useEffect(() => {
    if (user) {
      if (!user?.credits && !user?.fixedCredits) {
        if (window.localStorage.getItem('noCreditsSeen')) return
        setPopup('noCredits')
      } else if ((user?.credits || 0) + (user?.fixedCredits || 0) < 4) {
        if (window.localStorage.getItem('lowCreditsSeen')) return
        setPopup('lowCredits')
      } else if (user && !user?.seenWelcome) {
        setPopup('welcome')
      }
    }
  }, [user])

  const closeFn = async () => {
    if (popup === 'welcome') {
      setPopup(null)
      await setDoc(doc(db, 'usersV2', user?.id), { seenWelcome: true }, { merge: true })
      refetchUser()
    } else if (popup === 'lowCredits') {
      setPopup(null)
      window.localStorage.setItem('lowCreditsSeen', 'true')
    } else if (popup === 'noCredits') {
      setPopup(null)
      window.localStorage.setItem('noCreditsSeen', 'true')
    }
  }

  console.log('inviteModalState', inviteModalState)

  return (
    <div style={{ width: '100vw', height: '100%' }}>
      <Frame
        logo={{ topBarSource: "https://assets.codepen.io/6060109/PartnerUp+3.png", width: 150 }}
        showMobileNavigation={mobileNavigationActive}
        onNavigationDismiss={() => setMobileNavigationActive(false)}
        topBar={
          <TopBar showNavigationToggle
            onNavigationToggle={() => { setMobileNavigationActive(!mobileNavigationActive) }}
            userMenu={
              <TopBar.UserMenu
                actions={[{
                  items: [{
                    content: 'Sign out',
                    onAction: () => auth.signOut(),
                  }],
                }]}
                name={user?.name}
                detail={user?.brand}
                avatar={auth?.currentUser?.photoURL}
                initials={user?.name?.[0]}
                open={userMenuActive}
                onToggle={setUserMenuActive}
              />
            }
          />
        }
        navigation={
          <Navigation location="/">
            <Navigation.Section
              items={[
                {
                  onClick: () => navigate("/creators"),
                  label: "Creators",
                  icon: PersonIcon,
                  selected: location.pathname.includes('/creators'),
                  disabled: menuDisabled,
                  badge: unseenCount ? unseenCount?.toString() : null
                },
                {
                  onClick: () => navigate("/search"),
                  label: "Search",
                  icon: SearchIcon,
                  selected: location.pathname === '/search',
                  disabled: menuDisabled
                },
                {
                  onClick: () => navigate("/settings"),
                  label: "Account",
                  icon: SettingsIcon,
                  disabled: menuDisabled,
                  selected: location.pathname === '/settings'
                },
                {
                  onClick: () => navigate("/plan"),
                  label: "Subscription",
                  icon: CashDollarIcon,
                  disabled: menuDisabled,
                  selected: location.pathname === '/plan'
                },
              ]}
            />
            {
              /*
              <Navigation.Section title="Account"
                items={[
                  {
                    onClick: () => navigate("/tutorial"),
                    label: "Tutorial",
                    icon: InfoIcon,
                    disabled: menuDisabled,
                    selected: location.pathname === '/tutorial'
                  },
                ]}
                />
                */
            }
          </Navigation>
        }>
        <Box style={{ maxWidth: '1300px', height: '100%', margin: '20px auto', padding: '0 20px' }}>
          <CreditsPopup open={popup} onClose={closeFn} />
          {children}
        </Box>
      </Frame>
    </div>
  )
}
